import React, { Fragment, useState, useEffect } from "react";
import man from "../../../assets/images/dashboard/user.png";
import { User, LogOut } from "react-feather";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../../redux/auth/authActions";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

const UserMenu = () => {
  const { t } = useTranslation();
  const [profile, setProfile] = useState("");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    setProfile(user?.profile_image_url || man);
  }, [user]);

  const Logout = () => {
    Swal.fire({
      title: t("logout_warning"),
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: "#4466f2",
      cancelButtonText: t("action.cancel"),
      confirmButtonText: t("action.confirm"),
      focusCancel: true,
      customClass: {
        title: "custom-title",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logoutUser());
      }
    });
  };

  return (
    <Fragment>
      <li className="onhover-dropdown">
        <div className="d-flex align-items-center">
          <img
            className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded"
            height={50}
            width={50}
            src={profile}
            alt="header-user"
          />
        </div>
        <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
          <li>
            <Link
              className="text-nowrap"
              to="/edit-profile"
            >
              <User />
              {t("edit_profile")}
            </Link>
          </li>
          {/* <li>
            <a href="#javascript">
              <Settings />
              {"Settings"}
            </a>
          </li> */}
          <li>
            <Link className="text-nowrap" onClick={Logout}>
              <LogOut />
              {t("logout")}
            </Link>
          </li>
        </ul>
      </li>
    </Fragment>
  );
};

export default UserMenu;
